import { jsx } from "react/jsx-runtime";
import { DSFormLayoutBlockItem } from "@elliemae/ds-form-layout-blocks";
import { DSSingleComboBox } from "@elliemae/ds-form-single-combobox";
import { Grid } from "@elliemae/ds-grid";
import { useMemo, useEffect } from "react";
import { useFormState, useWatch } from "react-hook-form";
import _ from "lodash";
import { useSingleComboboxFieldUpdateLogic } from "../utils/fieldUpdateLogic";
import { useFieldVisibilityAndDisability } from "../utils/fieldVisibilityAndDisability";
import { useLoanDataFieldSelectorHook } from "../utils/utils";
const DocumentationType = ({
  renderedField,
  schemaForm,
  rules,
  id,
  name,
  label,
  required,
  pathValue,
  feedbackMessage,
  ui,
  options,
  visible,
  disabled,
  disableCheck,
  visibleCheck,
  preview
}) => {
  const singleComboboxFieldUpdateLogic = useSingleComboboxFieldUpdateLogic();
  const { isVisible, isDisabled } = useFieldVisibilityAndDisability({
    schemaForm,
    rules,
    visible,
    disabled,
    visibleCheck,
    disableCheck,
    preview
  });
  const { errors } = useFormState({ control: schemaForm.control });
  const errorMessage = _.get(errors, pathValue)?.message;
  const selfEmployed = useLoanDataFieldSelectorHook(
    "loanInformation.selfEmployedBorrower"
  );
  let valueAsString = "";
  const [incomeValue, watchedFieldValue] = useWatch({
    control: schemaForm.control,
    name: ["income", pathValue]
  });
  const allComboboxOptions = useMemo(() => {
    let newOpts = options.filter((option) => option.visible);
    if (name === "Non-QM Doc Level" && incomeValue) {
      if (incomeValue.toString() === "100") {
        newOpts = newOpts.filter((option) => Number(option.value) <= 2);
      } else if (incomeValue.toString() === "70") {
        newOpts = newOpts.filter((option) => Number(option.value) > 2);
      }
    }
    return newOpts.map((option) => ({
      dsId: `${option.id}`,
      type: "option",
      label: `${option.text}`,
      value: `${option.value?.toString()}`,
      default: option.default
    }));
  }, [options, incomeValue]);
  const getEmploymentValue = (val) => {
    if (name === "Employment") {
      if (val === "100") {
        if (selfEmployed.value === true) return "2";
        return "1";
      }
    }
    return val;
  };
  const selectedOption = useMemo(() => {
    valueAsString = String(getEmploymentValue(watchedFieldValue) ?? "");
    return allComboboxOptions.find((option) => option.value === valueAsString) || null;
  }, [allComboboxOptions, watchedFieldValue]);
  useEffect(() => {
    valueAsString = String(getEmploymentValue(watchedFieldValue) ?? "");
    schemaForm.setValue(pathValue, valueAsString);
  }, [watchedFieldValue]);
  return /* @__PURE__ */ jsx(Grid, { span: ui.col_size, style: { display: isVisible ? "block" : "none" }, children: /* @__PURE__ */ jsx(
    DSFormLayoutBlockItem,
    {
      name,
      label,
      inputID: name,
      required,
      feedbackMessage,
      hasError: !!errors[id] || !!errorMessage,
      validationMessage: errors[id]?.message?.toString() || errorMessage,
      children: /* @__PURE__ */ jsx(
        DSSingleComboBox,
        {
          ...renderedField,
          allOptions: allComboboxOptions,
          onChange: singleComboboxFieldUpdateLogic(
            renderedField,
            schemaForm,
            id
          ),
          selectedValue: selectedOption,
          id: pathValue,
          disabled: isDisabled,
          isNonClearable: true
        }
      )
    }
  ) });
};
export {
  DocumentationType
};
